import { TRANSLATION, Yup } from "@/imports-files/common/common";

export const SHARE_CV = {
                            share_with  :   '',
                            title_note  :   ''
                        };

export const SHARE_CV_VALIDATION_SCHEMA = Yup.object({
                                                            share_with  :   Yup.string().email(TRANSLATION('common:errors:invalid_email')),
                                                            title_note  :   Yup.string().required(TRANSLATION('common:errors:required'))                                                                                         
                                                    })
                 

                                                          